/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConfigurationForDistributorConsolidatedReport extends models.ConfigurationForFinOpsConsolidatedReport {
    constructor() {
        super();
        this.setDiscriminator("ConfigurationForDistributorConsolidatedReport");
    }

    getFixupPrototypeFunction() { return ConfigurationForDistributorConsolidatedReport.fixupPrototype; }

    static newInstance(model: Partial<ConfigurationForDistributorConsolidatedReport>): ConfigurationForDistributorConsolidatedReport {
        let obj = Object.assign(new ConfigurationForDistributorConsolidatedReport(), model);
        ConfigurationForDistributorConsolidatedReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConfigurationForDistributorConsolidatedReport>): ConfigurationForDistributorConsolidatedReport {
        if (!model) return null;
        return ConfigurationForDistributorConsolidatedReport.newInstance(<ConfigurationForDistributorConsolidatedReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConfigurationForDistributorConsolidatedReport) {
        if (!obj) return;

        models.ConfigurationForDistributorConsolidatedReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConfigurationForDistributorConsolidatedReport): boolean {
        if (models.ConfigurationForFinOpsConsolidatedReport.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ConfigurationForDistributorConsolidatedReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * When true, render the role-scoped Partner -> Customer -> Subscription cloud account hierarchy tree instead of a flat list. The UI surfaces this as a 'Cloud Account Hierarchy' group-by option.
     */
    cloud_account_hierarchy: boolean;

}
